import { Event } from "@bugsnag/js";

/*
 * Errors we deliberately drop before they reach Bugsnag. Keep this list short,
 * specific and commented — anything vague here will hide a real regression.
 */
const ignoredErrorMessages = [
  /*
   * A defect inside @firebase/auth's popup/redirect machinery. Serialising our
   * own calls (see libs/firebase.ts) removes the trigger we control, but the
   * SDK still trips this assertion asynchronously, outside the promise our
   * sign-in awaits, so it arrives unhandled with nothing to catch at the call
   * site. Tracked upstream in firebase-js-sdk#6923 and firebase-js-sdk#7093.
   */
  "INTERNAL ASSERTION FAILED: Pending promise was never set",
];

export const isIgnoredError = (event: Event) =>
  event.errors.some((error) =>
    ignoredErrorMessages.some((message) =>
      error.errorMessage.includes(message),
    ),
  );
